import { render } from "./PQueryAccount.vue?vue&type=template&id=fb8c0cf0&scoped=true"
import script from "./PQueryAccount.vue?vue&type=script&lang=js"
export * from "./PQueryAccount.vue?vue&type=script&lang=js"

import "./PQueryAccount.vue?vue&type=style&index=0&id=fb8c0cf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb8c0cf0"]])

export default __exports__